import React, { useState } from 'react';
import { Save, Loader2, Check } from 'lucide-react';

const SaveDraftButton = ({ onSave, data, translations }) => {
  const [isSaving, setIsSaving] = useState(false);
  const [isSaved, setSaved] = useState(false);
  const scenarioId = (JSON.parse(sessionStorage.getItem('currentScenario'))?.id || JSON.parse(sessionStorage.getItem('scenarioId'))?.scenarioId);

  const handleSave = async () => {
    if (isSaved) return;
    setIsSaving(true);

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`https://www.ia-schedule.com:4139/api/roster/drafts?scenarioId=${scenarioId}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        throw new Error('Failed to save draft');
      }

      setSaved(true);
      if (onSave) onSave();
    } catch (error) {
      console.error('Error saving draft:', error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <button
      onClick={handleSave}
      disabled={isSaving || isSaved}
      className={`
        flex items-center gap-2 px-6 py-3 rounded-lg
        ${isSaved
          ? 'bg-green-600 text-white cursor-not-allowed'
          : isSaving
            ? 'bg-blue-400 text-white cursor-not-allowed'
            : 'bg-blue-600 text-white hover:bg-blue-700'
        }
        transition-colors duration-200
      `}
    >
      {isSaved ? (
        <>
          <Check className="w-5 h-5" />
          {translations("generate.error.noSolution.savedDraft")}
        </>
      ) : isSaving ? (
        <>
          <Loader2 className="w-5 h-5 animate-spin" />
          {translations("generate.error.noSolution.savingDraft")}
        </>
      ) : (
        <>
          <Save className="w-5 h-5" />
          {translations("generate.error.noSolution.saveDraft")}

        </>
      )}
    </button>
  );
};

export default SaveDraftButton;